import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LoginPage.css'; // Custom CSS for additional styling

export default function Settings() {
    const navigate = useNavigate();
    
    const logout = () => {
        localStorage.clear();
        navigate("/login");
    }

    return (     
        <div className="settings-container">
            {/* Profile Header */}
            <div className="profile-header">
                <div className="avatar-container">
                    <img 
                        src={`https://ui-avatars.com/api/?rounded=true&name=${localStorage.getItem('name')}&size=120&background=random`} 
                        alt="User" 
                        className="user-avatar"
                    />
                </div>
                <div className="user-info">
                    <h2 className="user-name">{localStorage.getItem('name')}</h2>
                    <p className="user-id">ID: #{localStorage.getItem('userid').toString().padStart(4, '0')}</p>
                </div>
            </div>

            {/* Settings Menu */}
            <div className="settings-menu">
                <h3 className="menu-title"><i className="fa fa-cog"></i> Account Settings</h3>
                
                {/* <Link to="/profile" className="menu-item">
                    <div className="menu-icon">
                        <i className="fa fa-user-edit"></i>
                    </div>
                    <div className="menu-content">
                        <span>Update Profile</span>
                        <i className="fa fa-chevron-right"></i>
                    </div>
                </Link> */}


                <Link to="/bank" className="menu-item">
                    <div className="menu-icon">
                        <i className="fa fa-wallet"></i>
                    </div>
                    <div className="menu-content">
                        <span>Bank Details</span>
                        <i className="fa fa-chevron-right"></i>
                    </div>
                </Link>

                <Link to="/company" className="menu-item">
                    <div className="menu-icon">
                        <i className="fa fa-building"></i>
                    </div>
                    <div className="menu-content">
                        <span>About Company</span>
                        <i className="fa fa-chevron-right"></i>
                    </div>
                </Link>

                <Link to="/contact" className="menu-item">
                    <div className="menu-icon">
                        <i className="fa fa-headset"></i>
                    </div>
                    <div className="menu-content">
                        <span>Contact Us</span>
                        <i className="fa fa-chevron-right"></i>
                    </div>
                </Link>

                <div className="menu-item" onClick={logout}>
                    <div className="menu-icon">
                        <i className="fa fa-sign-out-alt"></i>
                    </div>
                    <div className="menu-content">
                        <span>Logout</span>
                        <i className="fa fa-chevron-right"></i>
                    </div>
                </div>
            </div>
        </div>
    );
}